import type { Product } from '~~/shared/types/store'
import {
  addRecentlyViewedProduct,
  readRecentlyViewedProducts,
  writeRecentlyViewedProducts,
} from '~~/app/utils/recentlyViewedProducts'

export function useRecentlyViewedProducts() {
  const products = ref<Product[]>([])
  const isLoaded = ref(false)

  function getStorage() {
    try {
      return window.localStorage
    }
    catch {
      return undefined
    }
  }

  function load() {
    if (!import.meta.client) return
    products.value = readRecentlyViewedProducts(getStorage())
    isLoaded.value = true
  }

  function record(product: Product) {
    if (!import.meta.client) return

    const storage = getStorage()
    const next = addRecentlyViewedProduct(product, readRecentlyViewedProducts(storage))
    writeRecentlyViewedProducts(next, storage)
    products.value = next
  }

  if (import.meta.client) {
    onMounted(() => {
      load()
      window.addEventListener('storage', load)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('storage', load)
    })
  }

  return {
    isLoaded: readonly(isLoaded),
    products: readonly(products),
    load,
    record,
  }
}
